import React, { FC } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import Icon from '../../../../@shared/icon';
import { TInputBox } from '../../../types/index.types';
import DictionaryTerm from '../../../../@shared/dictionaryTerm';

const InputBox: FC<TInputBox> = (props) => {
  const { searchTerm, setSearchTerm, t } = props;

  const handleKeyUp = (event) => {
    if (setSearchTerm) {
      setSearchTerm(event?.currentTarget?.value);
    }
  };

  return (
    <div className="model-details-specification-table-header__search-input">
      <div className={`model-details-specification-table-header__search-input__container ${searchTerm && 'typed-input'}`}>
        <Icon iconName="action-search" size={iconSize.dsk} color="gray" extraClassName="table-search-icon" />
        <div className="model-details-specification-table-header__search-input__inner-container">
          {searchTerm && (
            <label
              slot="label"
              htmlFor="table-header-search-input"
              className="model-details-specification-table-header__search-input__label"
            >
              <DictionaryTerm keyword="cnhi-tableInputLabel" />
            </label>
          )}
          <input
            id="table-header-search-input"
            name="Search"
            placeholder={t('cnhi-tableInputLabel')}
            type="text"
            className="model-details-specification-table-header__search-input__input"
            onKeyUp={handleKeyUp}
          ></input>
        </div>
      </div>
    </div>
  );
};
export default InputBox;
